module.exports = __webpack_public_path__ + "static/media/img38.db4b3549.jpg";